import { ProviderClient } from '../../abstract/provider.client'
import { PROPERTY_FILES_DOWNLOADED } from '../../abstract/provider.objects'
import { ProviderFirecrawlCommon } from '../common'

export const ProviderFirecrawlClient: ProviderClient = {
  key: ProviderFirecrawlCommon.key,
  description: {
    icon: <i className="las la-globe" style={{ fontSize: '20px' }}></i>,
    label: 'Scrapping',
    triggers: [],
    actions: [
      {
        key: 'crawl',
        label: 'Crawl',
        input: [
          {
            key: 'url',
            type: 'string',
          },
          {
            key: 'params',
            type: 'object',
            propsFormItem: {
              required: false,
            },
          },
        ],
        output: [PROPERTY_FILES_DOWNLOADED],
      },
      {
        key: 'scrape',
        label: 'Scrape',
        input: [
          {
            key: 'url',
            type: 'string',
          },
        ],
        output: [PROPERTY_FILES_DOWNLOADED],
      },
    ],
  },
}
